import React, {Component, Fragment} from "react";
import "../SliderQuotationContent.css";
import {Link} from 'react-router-dom';
import {FormattedMessage} from "react-intl";
import {BASE_URL, PAGE_OPEN_TYPE} from "../../../../../../configuration";

const LayerOptions = (props) => {
    if (props.layers === 1 || props.layers === 4) {
        return (
            <Fragment>
                <option value={0.8}>0.8mm</option>
                <option value={1.0}>1.0mm</option>
                <option value={1.2}>1.2mm</option>
                <option value={1.6}>1.6mm</option>
                <option value={2.0}>2.0mm</option>
            </Fragment>

        )
    } else if (props.layers === 2) {
        return (
            <Fragment>
                <option value={0.4}>0.4mm</option>
                <option value={0.6}>0.6mm</option>
                <option value={0.8}>0.8mm</option>
                <option value={1.0}>1.0mm</option>
                <option value={1.2}>1.2mm</option>
                <option value={1.6}>1.6mm</option>
                <option value={2.0}>2.0mm</option>
            </Fragment>

        )
    } else if (props.layers === 6) {
        return (
            <Fragment>
                <option value={1.2}>1.2mm</option>
                <option value={1.6}>1.6mm</option>
                <option value={2.0}>2.0mm</option>
            </Fragment>

        )
    }
};

class SliderQuotationContent1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            length: "100",
            width: "100",
            btnDisabled: false,
            quotation: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""
                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            }
        };

        this.setParamOnChange = this.setParamOnChange.bind(this);
        this.toPcbImageQuotation = this.toPcbImageQuotation.bind(this);
        this.onDimensionChange = this.onDimensionChange.bind(this);
        this.onParamChange = this.onParamChange.bind(this);
    }

    onDimensionChange = (event) => {
        let val = event.target.value;
        // let reg = /^[1-9]([0-9]*)(\.[0-9]{1,2})?$/;
        let reg = /^[1-9]([0-9]*)(\.[0-9]{0,2})?$/;
        let regGreater = /^[1-9]([0-9]*)(\.[0-9]{0,1})?$/;

        let　rex = /[\uFF10-\uFF19]/g;

        val = val.replace(rex, function (ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });

        val = val.replace(/\s/g, '');
        val = val.replace(/\u3002/g, ".");
        if (val === '') {
            if (event.target.name === "width") {
                this.setState({
                    width: '',
                    btnDisabled: true
                })
            }
            else if (event.target.name === "length") {
                this.setState({
                    length: '',
                    btnDisabled: true
                })
            }
        }
        else if (val > 100 && val.match(reg)) {
            if (val.match(regGreater)) {
                if (event.target.name === "width") {
                    this.setState({
                        width: val
                    }, () => {
                        if (this.state.width !== '' && this.state.length !== '') {
                            this.setState({
                                btnDisabled: false
                            })
                        }
                    })
                }
                else if (event.target.name === "length") {
                    this.setState({
                        length: val
                    }, () => {
                        if (this.state.width !== '' && this.state.length !== '') {
                            this.setState({
                                btnDisabled: false
                            })
                        }
                    })
                }
            } else {
                if (event.target.name === "width") {
                    this.setState({
                        width: '100'
                    }, () => {
                        if (this.state.width !== '' && this.state.length !== '') {
                            this.setState({
                                btnDisabled: false
                            })
                        }
                    })
                }
                else if (event.target.name === "length") {
                    this.setState({
                        length: '100'
                    }, () => {
                        if (this.state.width !== '' && this.state.length !== '') {
                            this.setState({
                                btnDisabled: false
                            })
                        }
                    })
                }
            }

        } else {
            if (event.target.name === "width") {
                this.setState({
                    width: val,
                    btnDisabled: false
                })
            }
            else if (event.target.name === "length") {
                this.setState({
                    length: val,
                    btnDisabled: false
                })
            }
        }

    };

    onParamChange = (event) => {
        let quotation = {...this.state.quotation};

        if(event.target.name === "thickness" && event.target.value === "0.4"){
            quotation.pcbParam["surfaceFinish"] = 2;
        }else {
            quotation.pcbParam["surfaceFinish"] = 0;
        }


        quotation.pcbParam[event.target.name] = parseFloat(event.target.value);
        this.setState({quotation});
    };

    setParamOnChange = (name, paramValue) => {

        let quotation = {...this.state.quotation};
        let reg = /^[1-9]([0-9]*)(\.[0-9]{0,2})?$/;
        let regGreater = /^[1-9]([0-9]*)(\.[0-9]{0,1})?$/;


        let value = paramValue;

        if (name === "length" || name === "width") {
            var rex = /[\uFF10-\uFF19]/g;

            let val = paramValue;
            val = val.replace(rex, function (ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 65248);
            });

            val = val.replace(/\s/g, '');
            val = val.replace(/\u3002/g, ".");


            if (val < 100) {
                if (val.match(reg)) {
                    quotation.pcbParam[name] = parseFloat(val);
                }
            } else {
                if (val.match(regGreater)) {
                    quotation.pcbParam[name] = parseFloat(val);
                }
            }

        } else {

        }

        this.setState({quotation}, () => {
            console.log("QUOOOOOOOOO====> ", this.state.quotation)
        });
    };

    toPcbImageQuotation = (event) => {

        this.setParamOnChange("length", this.state.length);
        this.setParamOnChange("width", this.state.width);

        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(this.state.quotation));

        // window.open(BASE_URL+'quotation/pcb', PAGE_OPEN_TYPE);

    };


    render() {
        return (
            <div className="row">
                <div className="text-center">
                    <label className="quotation-content1-heading">
                        <FormattedMessage id="app.image-slider.quotation.centent1-heading"
                                          defaultMessage="First, try the estimate"
                                          description=""/>
                    </label>
                </div>
                <div className="homePage-text-span-padding-20">
                    <span className="quotation-content-caption  caption-content-2">
                        {/*<FormattedMessage id="app.image-slider.quotation.centent1-description"*/}
                        {/*defaultMessage="You can easily estimate board manufacturing costs simply by entering the board size."*/}
                        {/*description=""/>*/}
                        <p className="font-size-13">
                                基板サイズを入力するだけで
                        </p>
                        <p className="font-size-13">
                                簡単に基板製造費用をお見積りできます。
                        </p>
                    </span>
                </div>
                <div className="col-md-12 text-center  move-div-up">
                    <table className="content-table">
                        <tbody>
                        <tr>
                            <td>
                                <div className="input-div text-left">
                                   <span className="font-size-13">
                                       <FormattedMessage id="app.image-slider.quotation.board-size"
                                                         defaultMessage="Board Size"
                                                         description=""/>
                                    </span>
                                    <table className="mm-table">
                                        <tbody>
                                        <tr className="mid-section-mm-table">
                                            <td><input name="width" onChange={this.onDimensionChange}
                                                       type="text" className="home-content-input"
                                                       value={this.state.width}
                                            />
                                            </td>
                                            <td><span className="color-text-black middle-symbol">x</span></td>
                                            <td><input type="text" onChange={this.onDimensionChange}
                                                       name="length" className="home-content-input"
                                                       value={this.state.length}
                                            /></td>
                                            <td className="mm-div"><span
                                                className="color-text-black">mm</span></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                            <td>
                                <div className="input-div text-left">
                                    <span className="font-size-13"> <FormattedMessage id="app.image-slider.quotation.quantity"
                                                      defaultMessage="Quantity"
                                                      description=""/>
                                    </span>
                                    <label className="custom-select">
                                        <select
                                            value={this.state.quotation.pcbParam.qty}
                                            onChange={this.onParamChange} name="qty"
                                            className="home-content-qty-select">
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={15}>15</option>
                                            <option value={20}>20</option>
                                            <option value={25}>25</option>
                                            <option value={30}>30</option>
                                            <option value={50}>50</option>
                                            <option value={75}>75</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                            {/*<option value={100+}>100+</option>*/}
                                        </select>
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="input-div text-left">
                                     <span className="font-size-13">
                                         <FormattedMessage id="app.image-slider.quotation.layers"
                                                      defaultMessage="Layer Structure"
                                                      description=""/>
                                     </span>
                                    <label className="custom-select">
                                        <select name="layer"
                                                value={this.state.quotation.pcbParam.layer}
                                            // value="2"
                                                onChange={this.onParamChange} className="home-content-layer-select">

                                            <option value={1}>片面</option>
                                            <option value={2}>2層（両面）</option>
                                            <option value={4}>4層</option>
                                            <option value={6}>6層</option>


                                        </select>
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="input-div text-left">
                                    <span className="font-size-13">
                                        <FormattedMessage id="app.image-slider.quotation.thickness"
                                                      defaultMessage="Thickness"
                                                      description=""/>
                                    </span>
                                    <label className="custom-select">
                                        <select name="thickness"
                                                value={this.state.quotation.pcbParam.thickness}
                                                onChange={this.onParamChange}
                                                className="home-content-thickness-select"
                                                placeholder="板厚">
                                            {/*<option defaultValue="板厚" className="default-select-val">板厚</option>*/}
                                            <LayerOptions layers={this.state.quotation.pcbParam.layer}/>
                                        </select>
                                    </label>
                                    {/*<FormFieldValidationError errors={this.state.thicknessError}/>*/}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    {/*<div className="btn-left-div"></div>*/}
                    {/*<Link to='/pcb_quotation/new'>*/}
                    {this.state.btnDisabled ?

                        <a>
                            <button className="btn btn-div font-color-click-change" disabled={true}>
                                <FormattedMessage id="app.image-slider.quotation.estimate"
                                                  defaultMessage="Estimate Start"
                                                  description=""/>&nbsp;
                                <i className="glyphicon glyphicon-circle-arrow-right icon-margin"></i>
                            </button>
                        </a>

                        :
                        <Link to='quotation/pcb'>
                            <a onClick={this.toPcbImageQuotation}>
                                <button className="btn btn-div font-color-click-change">
                                    <FormattedMessage id="app.image-slider.quotation.estimate"
                                                      defaultMessage="Estimate Start"
                                                      description=""/>&nbsp;
                                    <i className="glyphicon glyphicon-circle-arrow-right icon-margin"></i>
                                </button>
                            </a>
                        </Link>
                    }

                    <div className="btn-right-div"></div>
                </div>
            </div>
        );
    }

}

export default SliderQuotationContent1;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSliderQuotation/SliderQuotationContent1/SliderQuotationContent1.js